import { jasBoardEntityName } from '../../../../../backend/config/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const jasBoardVerificationHistoryStatusSchema = z.enum(['failed', 'active', 'outOfDate', 'inactive']);
export const jasBoardVerificationHistorySchema = z.object({
    status: jasBoardVerificationHistoryStatusSchema,
    name: z.string(),
    lastUpdatedAt: z.number().optional(),
    lastCheckedAt: z.number().optional(),
    lastSuccessAt: z.number().optional(),
    calculateAge: z.boolean().optional(),
    jasBoardId: z.string().uuid(),
});
export const columns = defineColumns({
    status: {
        type: 'string-required',
    },
    name: {
        type: 'string-required',
    },
    lastUpdatedAt: {
        type: 'number',
    },
    lastCheckedAt: {
        type: 'number',
    },
    lastSuccessAt: {
        type: 'number',
    },
    calculateAge: {
        type: 'boolean',
    },
    jasBoardId: {
        type: 'foreign-key',
        entity: jasBoardEntityName,
    },
});
